import $ from 'jquery';
import 'jquery-lazy';
import 'jquery-lazy/plugins/jquery.lazy.ajax';
import omit from 'lodash/omit';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

export default function lazyAjax(el, options = {}) {
  const { afterLoad, onError } = options;
  const opts = omit(options, ['afterLoad', 'onError']);

  const combinedOptions = Object.assign({
    onError: ($el) => {
      if (onError) {
        options.onError($el);
      }

      $el.trigger('lazy-ajax:error', [$el]);
    },
    afterLoad: ($el) => {
      if (afterLoad) {
        options.afterLoad($el);
      }

      $el.trigger('lazy-ajax:after-load', [$el]);
    },
    ajaxCreateData: ($el) => {
      const json = $el.data('lazy-json');
      if (!json) {
        return null;
      }

      return json;
    },
  }, opts);

  return $(el).Lazy(combinedOptions);
}

registerJQueryPlugin('lazyAjax', lazyAjax);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/lazy-ajax.js